import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

let params;

function init() {
    $(document).on("click", "#deleteSitebtn", function() {
        const siteId = $(this).closest("tr")
            .find("#siteId")
            .text();
        const container = $("#sites");
        params = {
            "url": "/api/site/deletesite/" + siteId + "/" + $("#personId").val()
        };
        dataaccess.post(params).done(function(result) {
            container.html(result);
        });
    });
}

export const siteTable = {
    init: init
};